import { Injectable } from '@angular/core';
import { TopFlop } from 'src/app/models/topflop';
import { TopFlopAll } from 'src/app/models/TopFlopAll';

@Injectable({
  providedIn: 'root'
})
export class TopFlopStore {
  title = 'Top Flop';
  viewAllPath = '/menu/viewall/topFlop';
  showLoader = false;

  records: TopFlop[];
  sortedRecords: TopFlop[];
  totalPages: number;

  allRecords: TopFlopAll[];
  allSortedRecords: TopFlopAll[];

  /*

    shortHeaderDictionary: { [key: string]: string } = {
      sottostante: 'Sottostante',
      ultimo: 'Ultimo',
      var: 'Var%'
    };
    shortHeaderArray = Object.keys(this.shortHeaderDictionary);

    extendedHeaderDictionary: { [key: string]: string } = {
      sottostante: 'Sottostante',
      ultimo: 'Ultimo',
      var: 'Var%',
      var5gg: 'Var% 5gg',
      varInizioAnno: 'Var% Inizio Anno',
      var1Anno: 'Var% 1 Anno',
      max52Sett: 'Max 52 Sett.',
      min52Sett: 'Min 52 Sett.'
    };
    extendedHeaderArray = Object.keys(this.extendedHeaderDictionary);
  */
  totalRecords: number;

  constructor() {
    this.records = [];
    this.sortedRecords = [];
  }

  load(records: TopFlop[]) {
    this.records = records;
    this.sortedRecords = this.records.slice();
  }

  loadAll(records: TopFlopAll[]){
    this.allRecords= records;
    this.allSortedRecords= this.allRecords.slice();
  }
}
